export default __webpack_public_path__ + "static/media/figo-addpet.27de188e.png";